"use strict";
exports.__esModule = true;
exports.Queue = void 0;
var Queue = (function () {
    function Queue(items) {
        if (items === void 0) { items = []; }
        this.items = [];
        this.enqueueItems(items);
    }
    Queue.prototype.enqueue = function (item) {
        this.items.unshift(item);
    };
    Queue.prototype.enqueueItems = function (items) {
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            this.enqueue(item);
        }
    };
    Queue.prototype.dequeue = function () {
        return this.items.pop();
    };
    Queue.prototype.first = function () {
        return this.items[this.size() - 1];
    };
    Queue.prototype.last = function () {
        return this.items[0];
    };
    Queue.prototype.size = function () {
        return this.items.length;
    };
    Queue.prototype.isEmpty = function () {
        return this.size() === 0;
    };
    return Queue;
}());
exports.Queue = Queue;
//# sourceMappingURL=queue.js.map